import {
  SET_ROVER,
} from '../constants/actionTypes';

const rover = (state = {}, action) => {
  switch (action.type) {
    case SET_ROVER:
      return {
        ...state,
        wheelDistance: action.payload.rover?.wheelDistance ?? state.wheelDistance,
        length: action.payload.rover?.length ?? state.length,
        turningRadius: action.payload.rover?.turningRadius ?? state.turningRadius,
        positionOfRotationAxis:  action.payload.rover?.positionOfRotationAxis ?? state.positionOfRotationAxis,
        positionOfGnsReceiver:  action.payload.rover?.positionOfGnsReceiver ?? state.positionOfGnsReceiver
      };
    default:
      return state;
  }
};

export default rover;